import { formDataToEntity } from '../formDataToEntity';
import { DocumentDualReceiptEntity, DualReceiptFormResult } from './types';

export function createFormDataToEntity<T extends DocumentDualReceiptEntity>(
  type: T['type']
): (data: DualReceiptFormResult) => T {
  return (data: DualReceiptFormResult) => {
    const receipts = Object.values(data.resultReceipts);
    const newReceipts = receipts.map((receipt) => formDataToEntity(receipt));
    return { receipts: newReceipts, type: type } as T;
  };
}
